import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { getCategories } from "../../utils/measurements";
import { getCart } from "../../services/cartService";

// Components
import Heading from "../../elements/heading";
import CartItem from "../../sections/cart-item";
import IconLink from "../../elements/icon-link";
import LoadingSpinner from "../../elements/loading-spinner";

import PrimaryButton from "../../elements/primary-button";
import EmptyCartMessage from "../../sections/empty-cart-message";
import { selectCartItemsState, staffInfoSelector } from "../../selectors/application";
import { addToCartItems, hideCartRefreshBanner, removeCartItems, setSessionIdAction, showCartRefreshBanner, updateCartAction } from "../../redux/actions/actions";
import transform from "../../utils/jsonpath-object-transform";
import { mappingCartMergeToCartItem } from "../../mappings/ProductDetail";
import "./style.scss";
import { addCartItem, removeCartItem } from "../../services/cartService";
import { MathUtils } from "../../utils";
import { generateReactKey } from "../../utils/reactKey";
import { cartInfoSelector } from "../../selectors/gears-checkout";
import api from "../../utils/api";
import { getDeliveryMethods } from "../../services/orderService";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction, setDiffAddrAction, setPickupStoreAction } from "../../redux/actions/gears-checkout";

const Cart = props => {
  const { match } = props;
  const { rendering, fields, sitecoreContext, user, lang, cartInfo, updateCart, showCartRefreshBanner, clearBillingFormData, clearShippingFormData, setDiffAddr, clearContactFormData, setPickupStore, staffInfo } = props;
  const history = useHistory();
  const { gearsLoginLink, gearsDeliveryLink } = sitecoreContext.route.fields;
  const {
    titleType,
    titleBody,
    vatDisclaimer,
    vatTitle,
    // vatAmount = { value: MathUtils.priceFormat(0, lang) },
    availablePaymnetOptionTitle,
    availablePaymnetOptionImages,
    availablrPaymnetOptionsDisclaimer,
    availableShippingOptionsTitle,
    availableShipiingOptionsDisclaimer,
    contiunueShippingButton,
    contiuneToCheckoutButton,
    shippingTitle,
    shippingDisclaimer,
    shippingCost,
    emptyCart,
    continueToAction,
    productPageLink
  } = fields;

  const [items, setItem] = useState([]);
  const [productsInCart, setProductToCartItemData] = useState([]);
  const [totalPrice, setTotalPrice] = useState("");
  const [shippingPrice, setShippingPrice] = useState("");
  const [isCartLoading, setCartLoading] = useState(true);
  const [spuObj, setSpu] = useState({});
  const [usableStockArray, setUsableStockArray] = useState([]);

  useEffect(() => {
    if (cartInfo) {
      fetchCartItemsWithVariation().then(() => {
        setCartLoading(false);
      });
    }
  }, [cartInfo]);

  async function getUsableStock(items) {
    let _items = [];
    for (const item of items) {
      await api.product.sku.get({ skuId: item.skuId }).then(skuResponse => {
        let _item = {
          skuId: item.skuId,
          quantity: item.quantity,
          usableStock: skuResponse.obj.usableStock
        };
        _items.push(_item);
      });
    }
    setUsableStockArray(_items);
    if (_items.filter(item => item.quantity > item.usableStock).length) {
      showCartRefreshBanner();
    }
  }

  const fetchCartItemsWithVariation = async () => {
    hideCartRefreshBanner();
    setCartLoading(true);
    const currentShoppingCart = { obj: cartInfo };

    let mappingResultToCartItem = transform(currentShoppingCart, mappingCartMergeToCartItem(currentShoppingCart));
    const promotionTotal = mappingResultToCartItem.items.map(item => item.promotionTotal).reduce((a, b) => a + b, 0);
    getUsableStock(mappingResultToCartItem.items);
    setProductToCartItemData({ ...mappingResultToCartItem.items, ...productsInCart });
    mapProductsToStoreName(mappingResultToCartItem.items);
    setTotalPrice(mappingResultToCartItem.data.afterDiscountTotalPrice ? mappingResultToCartItem.data.afterDiscountTotalPrice - promotionTotal : 0);
    getDeliveryCost(
      mappingResultToCartItem.data.skuList?.map(i => {
        return i.spuId;
      }),
      mappingResultToCartItem.items?.map(i => {
        return i.skuId;
      }),
      mappingResultToCartItem.data.afterDiscountTotalPrice
    );
  };

  const mapProductsToStoreName = products => {
    let result = products.reduce(function(r, a) {
      r[a.storeName] = r[a.storeName] || [];
      r[a.storeName].push(a);
      return r;
    }, Object.create(null));
    let newarray = [];
    newarray.push(result);
    setItem(newarray);
  };

  const changeQuantityCallback = async (product, storeName, value) => {
    let attributMap = {};
    product.details.map(variant => {
      attributMap[variant.title] = variant.value;
    });
    const productObj = {
      spuId: product.spuId,
      skuId: product.skuId,
      skuAttributeValueMap: attributMap
    };
    setSpu(productObj);
    if (value > -1) {
      const res = await addCartItem(product.skuId);
      updateCart(res.obj);
      // addToCartItems(productObj);
    } else {
      const res = await removeCartItem(product.skuId, 1);
      updateCart(res.obj);
      // removeCartItems(productObj);
    }
    await getCart(lang);
  };
  const removeProductCallback = async (product, storeName) => {
    /*let productObj = {
      spuId: product.spuId,
      skuId: product.skuId
    };*/
    const res = await removeCartItem(product.skuId, product.quantity);
    updateCart(res?.obj);
    await getCart(lang);
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "removeFromCart",
      products: [
        {
          name: product.name,
          id: product.skuId,
          price: product.discountedPrice ? product.discountedPrice : product.price,
          quantity: product.quantity,
          brand: product?.brand,
          category: getCategories(product.categories),
          variant: product.spuId
        }
      ]
    });
    // removeCartItems(productObj);
  };

  const getDeliveryCost = async (spuIds, skuIds, totalAmount) => {
    const { obj: userPromotions } = await api.user.promotion(null, {
      skuIds
    });
    const promotion = userPromotions.find(x => x.meetConditionsAmt < totalAmount);
    if (promotion) {
      setShippingPrice(shippingCost.value);
    } else {
      // get cost of Standard shipping
      const deliverymethods = await getDeliveryMethods(spuIds);
      const standard = deliverymethods.find(d => d?.deliveryMethodCode === "DELIVERYMETHOD02");

      let priceFormatted = MathUtils.priceFormat(standard?.cost, lang);

      setShippingPrice(priceFormatted);
    }
  };
  const checkoutButtonProps = contiuneToCheckoutButton
    ? {
        buttonText: contiuneToCheckoutButton.fields.buttonText.value,
        iconName: contiuneToCheckoutButton.fields.iconName,
        colorScheme: contiuneToCheckoutButton.fields.colorScheme || {
          fields: { phrase: { value: "green" } }
        },
        callback: evt => {
          clearBillingFormData();
          clearShippingFormData();
          clearContactFormData();
          setPickupStore(null);
          setDiffAddr(null);
          if (user && !staffInfo) {
            history.push(gearsDeliveryLink.value.href);
          } else {
            history.push(gearsLoginLink.value.href);
          }
        }
      }
    : null;

  return (
    <section className="your-cart grid padding-top-small padding-bottom-default" datasourceid={rendering.dataSource}>
      <Heading html={titleBody} type={titleType} typographyClass="type-h1" className="heading" />

      <div className="main-cart-content">
        {isCartLoading && <LoadingSpinner />}
        {items &&
          items.map(item => {
            return (
              <React.Fragment key={generateReactKey()}>
                {Object.keys(item).map((store, i) => {
                  return (
                    <div className="items-from-store" key={generateReactKey()}>
                      <span className="store-name">{store}</span>
                      {item[store].map((product, index) => {
                        const totalDiscountedPrice = product.discountedPrice * product.quantity;
                        return (
                          <CartItem
                            {...{
                              ...product,
                              usableStock: usableStockArray.find(x => x.skuId === product.skuId)?.usableStock,
                              price: product.totalPrice,
                              discountedPrice: totalDiscountedPrice,
                              link: {
                                url: `${productPageLink.value?.href}${product.productPath}`
                              }
                            }}
                            key={product.name + "-" + index}
                            changeQuantityCallback={value => {
                              changeQuantityCallback(product, store, value);
                            }}
                            removeCallback={() => removeProductCallback(product, store)}
                            showLarge={true}
                            match={match}
                          />
                        );
                      })}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        {!isCartLoading && (items.length === 0 || Object.keys(items[0]).length === 0) && emptyCart && <EmptyCartMessage text={emptyCart.value} large />}
      </div>

      <div className="cart-bottom-info">
        {/* Only show shipping if there is items in the cart */}
        {items.length > 0 && Object.keys(items[0]).length > 0 && (
          <div className="cart-info-row border">
            <div>
              <span>{shippingTitle.value}</span>
              <span>{shippingPrice}</span>
            </div>
            <p className="disclaimer">{shippingDisclaimer.value}</p>
          </div>
        )}

        {vatTitle && (
          <div className="cart-info-row border">
            <div>
              <span>{vatTitle.value}</span>
              <span>{isNaN(totalPrice) ? "" : MathUtils.priceFormat(totalPrice, lang)} </span>
            </div>
            <p className="disclaimer">{vatDisclaimer.value}</p>
          </div>
        )}

        {/* Only show these if there is items in the cart */}
        {items.length > 0 && Object.keys(items[0]).length > 0 && (
          <>
            {checkoutButtonProps && <PrimaryButton {...checkoutButtonProps} />}
            {contiunueShippingButton && <IconLink {...contiunueShippingButton.fields} />}

            {items.length > 0 && Object.keys(items[0]).length > 0 && (
              <div className="cart-info-row">
                <div>
                  <span>{availablePaymnetOptionTitle.value}</span>
                  <p className="disclaimer">{availablrPaymnetOptionsDisclaimer.value}</p>
                </div>
                <div className="right-image-container">
                  {availablePaymnetOptionImages &&
                    availablePaymnetOptionImages.map((opt, index) => {
                      if (opt.fields.image && opt.fields.image.value.src)
                        return (
                          <div className="image-container payments" key={opt.fields.image.value.alt + "-" + index}>
                            <img src={opt.fields.image.value.src} alt={opt.fields.image.value.alt} />
                          </div>
                        );
                    })}
                </div>
              </div>
            )}

            {items.length > 0 && Object.keys(items[0]).length > 0 && (
              <div className="cart-info-row">
                <div>
                  <span>{availableShippingOptionsTitle.value}</span>
                  <p className="disclaimer">{availableShipiingOptionsDisclaimer.value}</p>
                </div>
              </div>
            )}
          </>
        )}

        {emptyCart && (items.length === 0 || Object.keys(items[0]).length === 0) && continueToAction && <PrimaryButton {...continueToAction.fields} />}
      </div>
    </section>
  );
};

Cart.propTypes = {
  heading: PropTypes.object,
  items: PropTypes.array,
  shipping: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.string,
    disclaimer: PropTypes.string
  }),
  vat: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.string,
    disclaimer: PropTypes.string
  }),
  checkoutCTA: PropTypes.object,
  contiuneShoppingCTA: PropTypes.object,
  shippingOptionsImages: PropTypes.object,
  emptyCart: PropTypes.shape({
    cta: PropTypes.object
  }),
  changeQuantityOfProduct: PropTypes.func,
  removeProduct: PropTypes.func
};

const mapStateToProps = state => ({
  cartInfo: cartInfoSelector(state),
  cartItems: selectCartItemsState(state),
  user: state.user,
  sessionId: state.sessionId,
  staffInfo: staffInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  updateCart: data => dispatch(updateCartAction(data)),
  addToCartItems: spuObj => dispatch(addToCartItems(spuObj)),
  removeCartItems: spuObj => dispatch(removeCartItems(spuObj)),
  showCartRefreshBanner: () => dispatch(showCartRefreshBanner()),
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  clearBillingFormData: data => dispatch(clearBillingInfoAction(data)),
  clearShippingFormData: data => dispatch(clearShippingInfoAction(data)),
  setDiffAddr: data => dispatch(setDiffAddrAction(data)),
  clearContactFormData: data => dispatch(clearContactInfoAction(data)),
  setPickupStore: data => dispatch(setPickupStoreAction(data)),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withSitecoreContext()(Cart));
